<template>
    <div class="text-center">
        <v-dialog width="1700" v-model="sheetShown" persistent scrollable class="flex flex-direction: column;">

            <v-card>
                <!-- >>> Upper ButtonBar ----------------------------------- -->
                <v-bottom-navigation v-model="colorvalue" :background-color="get_ButtonBarBackgroundColor" height="72" dark shift horizontal>
                    <div class="vertical-center" v-if="eventRecord && eventRecord.data.legInfo">
                        {{ eventRecord.data.startDate | dayjsFormatDate2 }}, {{ eventRecord.data.name }}, {{ eventRecord.data.legInfo.aptFrom.aptCode }}-{{ eventRecord.data.legInfo.aptTo.aptCode }}, (U) {{ eventRecord.data.startDate | dayjsFormatDateTime }}-{{ eventRecord.data.endDate | dayjsFormatDateTime }}
                        <br /><span style="font-weight: 300; font-size: 0.9rem;">{{ crewValuesForTitle }}</span>
                    </div>

                    <div class="flex-grow-1"></div>

                    <v-btn @click="showDialog_Roles = true" :disabled="!isButtonAllowed(eventRecord)">
                        <span>Roles</span>
                        <v-icon>mdi-key</v-icon>
                    </v-btn>

                    <v-btn @click="showDialog_DutyFlags = true" :disabled="!isButtonAllowed(eventRecord)">
                        <span>DutyFlags</span>
                        <v-icon>mdi-chess-queen</v-icon>
                    </v-btn>

                    <v-btn @click="showDialog_CommanderDecisions = true" :disabled="!isButtonAllowed(eventRecord)">
                        <span>Commander Decisions</span>
                        <v-icon>mdi-account-tie-hat</v-icon>
                    </v-btn>

                    <v-btn @click="showDialog_CheckinCheckout = true" :disabled="!isButtonAllowed(eventRecord)">
                        <span>Ci/Co Times</span>
                        <v-icon>mdi-airplane-clock</v-icon>
                    </v-btn>

                    <!-- <v-btn @click="showDialog_SplitDuty = true">
                        <span>Split Duty</span>
                        <v-icon>mdi-call-split</v-icon>
                    </v-btn> -->
                </v-bottom-navigation>
                <!-- >>> Upper ButtonBar ----------------------------------- -->


                <!-- >>> Crew Details -------------------------------------- -->
                <sdr-crew-details-list
                    :eventRecord="eventRecord"
                    :editorMode="editorMode"
                    :smallScreen="shortHeight || shortWidth">
                </sdr-crew-details-list>
                <!-- <<< Crew Detals --------------------------------------- -->


                <!-- >>> Member Details ------------------------------------ -->
                <v-card-text class="mt-1" style="height:800px; background-color: white;">
                    <!-- <v-container :style="{maxWidth: shortHeight || shortWidth ? '100%' : null}" style="padding:10px !important;"> -->
                        <v-stepper v-model="formStepper" non-linear class="stepper">
                            <sdr-stepper-header
                                :editorMode="editorMode"
                                :validations="validation"
                                @change="onChange_StepperHeader"
                            />

                            <!-- >>> Stepper: 1 ------------------------ -->
                            <v-stepper-content step="1" ref="stepperContent1">
                                <sdr-step1-content>

                                </sdr-step1-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 2 ------------------------ -->
                            <v-stepper-content step="2" ref="stepperContent2">
                                <sdr-step2-content>

                                </sdr-step2-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 3 ------------------------ -->
                            <v-stepper-content step="3" ref="stepperContent3">
                                <sdr-step3-content>

                                </sdr-step3-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 4 ------------------------ -->
                            <v-stepper-content step="4" ref="stepperContent4">
                                <sdr-step4-content>

                                </sdr-step4-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 5 ------------------------ -->
                            <v-stepper-content step="5" ref="stepperContent5">
                                <sdr-step5-content>

                                </sdr-step5-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 6 ------------------------ -->
                            <v-stepper-content step="6" ref="stepperContent6">
                                <sdr-step6-content>

                                </sdr-step6-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 7 ------------------------ -->
                            <v-stepper-content step="7" ref="stepperContent7">
                                <sdr-step7-content>

                                </sdr-step7-content>
                            </v-stepper-content>

                            <!-- >>> Stepper: 8 ------------------------ -->
                            <v-stepper-content step="8" ref="stepperContent8">
                                <sdr-step8-content>

                                </sdr-step8-content>
                            </v-stepper-content>
                        </v-stepper>
                    <!-- </v-container> -->
                </v-card-text>
                <!-- <<< Member Details ------------------------------------ -->


                <!-- >>> Action Bar ---------------------------------------- -->
                <hr>

                <sdr-stepper-action-bar
                    editorMode="create"
                    :editorFlightLegMode="editorFlightLegMode"
                    @close="onClick_CloseSheet"
                />
                <!-- <<< Action Bar ---------------------------------------- -->
            </v-card>

        </v-dialog>


        <!-- >>> Dialogs --------------------------------------------------- -->
        <sdr-dialog-roles v-model="showDialog_Roles"></sdr-dialog-roles>
        <sdr-dialog-dutyflags v-model="showDialog_DutyFlags"></sdr-dialog-dutyflags>
        <sdr-dialog-commanderdecisions v-model="showDialog_CommanderDecisions"></sdr-dialog-commanderdecisions>
        <sdr-dialog-checkin-checkout v-model="showDialog_CheckinCheckout"></sdr-dialog-checkin-checkout>
    </div>
</template>

<script>
    import Vue from 'vue';

    import BottomSheet from "./BottomSheet.vue";
    import CrewDetailsList from "./CrewDetailsList.vue";
    import Step1Content from "./BottomSheet/Step1Content.vue";
    import Step2Content from "./BottomSheet/Step2Content.vue";
    import Step3Content from "./BottomSheet/Step3Content.vue";
    import Step4Content from "./BottomSheet/Step4Content.vue";
    import Step5Content from "./BottomSheet/Step5Content.vue";
    import Step6Content from "./BottomSheet/Step6Content.vue";
    import Step7Content from "./BottomSheet/Step7Content.vue";
    import Step8Content from "./BottomSheet/Step8Content.vue";

    import DialogRoles from "./dialogs/Dialog_Roles.vue";
    import DialogDutyFlags from "./dialogs/Dialog_DutyFlags.vue";
    import DialogCommanderDecisions from "./dialogs/Dialog_CommanderDecisions.vue";
    import DialogCheckinCheckout from "./dialogs/Dialog_CheckinCheckout.vue";

    import { mapActions, mapGetters } from 'vuex';


    export default {
        name: 'BottomSheetCreate',
        extends: BottomSheet,

        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-crew-details-list': CrewDetailsList,
            'sdr-step1-content': Step1Content,
            'sdr-step2-content': Step2Content,
            'sdr-step3-content': Step3Content,
            'sdr-step4-content': Step4Content,
            'sdr-step5-content': Step5Content,
            'sdr-step6-content': Step6Content,
            'sdr-step7-content': Step7Content,
            'sdr-step8-content': Step8Content,

            'sdr-dialog-roles': DialogRoles,
            'sdr-dialog-dutyflags': DialogDutyFlags,
            'sdr-dialog-commanderdecisions': DialogCommanderDecisions,
            'sdr-dialog-checkin-checkout': DialogCheckinCheckout,

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                colorvalue: 0,
                // >>> ------------------------------------
                showDialog_Roles: false,
                showDialog_DutyFlags: false,
                showDialog_CommanderDecisions: false,
                showDialog_CheckinCheckout: false,
                showDialog_SplitDuty: false,
                // >>> ------------------------------------
                crewValuesForTitle: ''
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            sheetShown(val) {

                let me = this;


                if (val === true) {
                    me.firstCallFinished = false; // reset
                }

            }, // eo function sheetShown()


            get_flights_CrewDetails_Reduced(v) {

                this.crewValuesForTitle = ''; // reset
                v.forEach(member => {


                    this.crewValuesForTitle += member.crewCode;
                    if (member.roles.length > 0) {
                        this.crewValuesForTitle += '(';
                        member.roles.forEach(role =>{
                            this.crewValuesForTitle += role[0].toUpperCase();
                        });
                        this.crewValuesForTitle += ')';
                    }
                    this.crewValuesForTitle += member.onDuty === true ? ' (DU)' : '';
                    this.crewValuesForTitle += member.takeoff === true || member.landing === true ? ' (TL)' : '';
                    this.crewValuesForTitle += member.manualStatus === 'C' ? ' (cd)' : '';
                    this.crewValuesForTitle += member.manualStatus === 'E' ? ' (e)' : '';

                    this.crewValuesForTitle += ' '; // space
                });

            }, // eo function get_flights_CrewDetails_Reduced()

        },// eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_Reduced',
                'get_shared_IsEditingInThePastAllowed',
            ]),


            /*******************************************************************
            * get_ButtonBarBackgroundColor()
            *
            * Desc:
            * Note: 'blue-grey', 'teal', 'brown', 'indigo', 'blue-grey'
            *
            */
            get_ButtonBarBackgroundColor () {

                let me = this;

                me.$toc('>>> views/flights/componensts/core/BottomSheetCreate.vue >>> computed/get_ButtonBarBackgroundColor');
                switch (this.colorvalue) {
                    case 0: return 'blue-grey'
                    case 1: return 'blue-grey'
                    case 2: return 'blue-grey'
                    case 3: return 'blue-grey'
                }

            }, // eo function get_ButtonBarBackgroundColor()

        },// eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {


            /*******************************************************************
            * isButtonAllowed()
            *
            * Desc:
            * Note:
            *
            */
            isButtonAllowed (eventRecord) {

                let me = this,
                    isAllowed = true;


                me.$toc('>>> views/flights/componensts/core/BottomSheetCreate.vue >>> isButtonAllowed');
                if (eventRecord === null || eventRecord === undefined) {
                    return false;
                }
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [eventRecord.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    // Vue.prototype.$toasted.global.sdr_app_info({
                    //     message: 'Note: Dear User, no Changes in Past possible.'
                    // });
                    isAllowed = false;
                }


                return isAllowed;

            }, // eo function isButtonAllowed()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__text {
        font-weight: 400 !important;
        font-size: 0.9rem;
        color: #333;
    }



    .v-item-group.v-bottom-navigation .v-btn {
        font-weight: 400 !important;
        font-size: 0.9rem;
    }
</style>

<style>
    .stepper {
        overflow: visible;
    }

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 75%;
    }


    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 1.1rem;
        font-weight: 600;
    }
</style>